<template>
  <div>
    <v-card class="overflow-hidden">
      <v-card-text>
        <v-row>
          <v-col>
            <customer-autocomplete-filter
              :fatherEditedCustomer="filterRepair"
              :editedCustomerIndex="-1"
              :customerName="'quotation_customer_number'"
              @setFilterCustomer="setFilterCustomer"
            />
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('serialnumber_repair_number')"
              v-model="filterRepair.RepairNumber"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_license_plate')"
              v-model="filterRepair.LicensePlate"
            ></v-text-field>
          </v-col>
          <v-col v-show="$vuetify.breakpoint.mdAndUp">
            <v-autocomplete
              :items="maintenanceEngineers"
              item-text="NickName"
              item-value="UserName"
              :label="$t('installation_notice_engineer')"
              v-model="filterRepair.MaintenanceEngineers"
              :loading-text="$t('common_get_data')"
              :no-data-text="$t('common_no_results')"
              chips
              small-chips
              multiple
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-autocomplete
              :items="allSpecialNeedList"
              item-text="Name"
              item-value="Id"
              :label="$t('quotation_special_need')"
              v-model="filterRepair.SpecialNeedId"
              :loading-text="$t('common_get_data')"
              :no-data-text="$t('common_no_results')"
            ></v-autocomplete>
          </v-col>
          <v-col>
            <date-picker
              :dateName="'installation_acceptance_start_done_time'"
              :isAllTextFieldDisabled="false"
              @setDate="setStartDoneTime"
            />
          </v-col>
          <v-col>
            <date-picker
              :dateName="'installation_acceptance_end_done_time'"
              :isAllTextFieldDisabled="false"
              @setDate="setEndDoneTime"
            />
          </v-col>
          <v-col>
            <v-btn class="mt-2" color="primary" @click="getRepair">
              {{ $t('quotation_item_new_install_search') }}</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-data-table
      :headers="repairDataTableHeaders"
      :items="repairList"
      class="elevation-1 my-5"
      :loading="isRepairLoading"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :server-items-length="totalRows"
      :options="currentOptions"
      @update:options="updateOptions"
      :header-props="headerProps"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('repair_toolbar_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="isShowEditRepairDialog" fullscreen persistent>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ $t('repair_card_title') }}</span>
              </v-card-title>
              <v-card-text>
                <v-row class="mt-2">
                  <v-dialog v-model="isShowBackDialog" persistent>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        :disabled="editedRepair.IsAccept"
                        class="mx-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ $t('installation_acceptance_back') }}
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title class="text-h5">
                        {{ $t('installation_acceptance_back_reason_message') }}
                      </v-card-title>
                      <v-card-text>
                        <v-textarea
                          outlined
                          v-model="backReason"
                          :label="$t('installation_acceptance_back_reason')"
                        ></v-textarea>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="isShowBackDialog = false">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="isBack">
                          {{ $t('common_confirm') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-btn
                    color="primary"
                    :disabled="
                      !editedRepair.IsDone || editedRepair.IsTrack || editedRepair.IsAcceptance
                    "
                    @click="isTrack"
                    class="mx-2"
                  >
                    {{ $t('installation_acceptance_track_btn') }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="!editedRepair.IsDone || editedRepair.IsAcceptance"
                    @click="isAcceptance"
                    class="mx-2"
                  >
                    {{ $t('installation_acceptance_is_acceptance') }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    class="mx-2"
                    @click="throwFlow"
                    :disabled="
                      !editedRepair.IsAcceptance ||
                        editedRepair.IsThrowToResume ||
                        (editedRepair.InResumeItems.length === 0 &&
                          editedRepair.NotInResumeItems.length === 0)
                    "
                    :loading="isLoadingThrowFlowBtn"
                    v-if="editedRepair.FixType !== fixType.Photo"
                  >
                    轉拋
                  </v-btn>
                  <input
                    type="file"
                    ref="file"
                    style="display: none"
                    multiple="multiple"
                    @change="uploadPhoto"
                  />
                  <!-- multiple="multiple" -->
                  <v-btn
                    fab
                    text
                    small
                    color="primary"
                    @click="openFileDialog"
                    :disabled="editedRepair.IsAcceptance || !editedRepair.IsDone"
                  >
                    <!--  -->
                    <v-icon>
                      mdi-paperclip
                    </v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <div style="color:red; margin-right:100px" v-if="!editedRepair.IsAccept">
                    <v-icon color="error">
                      mdi-alert-box
                    </v-icon>
                    {{ $t('installation_acceptance_status_is_accept') }}
                  </div>
                  <div
                    style="color:green; margin-right:100px"
                    v-if="editedRepair.IsAccept && !editedRepair.IsDone"
                  >
                    <v-icon color="success">
                      mdi-checkbox-marked-outline
                    </v-icon>
                    {{ $t('installation_acceptance_status_accept') }}
                  </div>
                  <div
                    style="color:green; margin-right:100px"
                    v-if="
                      editedRepair.IsDone && !editedRepair.IsTrack && !editedRepair.IsAcceptance
                    "
                  >
                    <v-icon color="success">
                      mdi-checkbox-marked-outline
                    </v-icon>
                    {{ $t('installation_acceptance_status_done') }}
                  </div>
                  <div
                    style="color:cornflowerblue; margin-right:100px"
                    v-if="editedRepair.IsTrack && !editedRepair.IsAcceptance"
                  >
                    <v-icon color="blue">
                      mdi-checkbox-marked-outline
                    </v-icon>
                    {{ $t('installation_acceptance_status_track') }}
                  </div>
                  <div
                    style="color:green; margin-right:100px"
                    v-if="editedRepair.IsAcceptance && !editedRepair.IsThrowToResume"
                  >
                    <v-icon color="success">
                      mdi-checkbox-marked-outline
                    </v-icon>
                    {{ $t('installation_acceptance_status_acceptance') }}
                  </div>
                  <div
                    style="color:green; margin-right:100px"
                    v-if="editedRepair.IsThrowToResume && !editedRepair.IsThrowToStock"
                  >
                    <v-icon color="success">
                      mdi-checkbox-marked-outline
                    </v-icon>
                    {{ $t('repair_status_throw') }}
                  </div>
                  <div style="color:green; margin-right:100px" v-if="editedRepair.IsThrowToStock">
                    <v-icon color="success">
                      mdi-checkbox-marked-outline
                    </v-icon>
                    {{ $t('repair_throw_stock_status') }}
                  </div>
                </v-row>
              </v-card-text>
              <v-tabs>
                <v-tab href="#tab-1">{{ $t('fix_tab_title') }}</v-tab>
                <v-tab
                  href="#tab-2"
                  v-if="editedRepair.FixFileNameList && editedRepair.FixFileNameList.length > 0"
                  >{{ $t('repair_fix_photo') }}</v-tab
                >
                <v-tab
                  href="#tab-3"
                  v-if="editedRepair.FileNameList && editedRepair.FileNameList.length > 0"
                  >{{ $t('installation_acceptance_engineer_photo') }}</v-tab
                >
                <v-tab href="#tab-4">{{ $t('quotation_tab_third') }}</v-tab>
                <v-tab-item value="tab-1">
                  <v-card flat>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedRepair.Number"
                              :label="$t('serialnumber_repair_number')"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="turnFixToRepairDate"
                              :label="$t('installation_notice_create_time')"
                              disabled
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedRepair.CustomerNumber"
                              :label="$t('quotation_customer_number')"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedRepair.CustomerName"
                              :label="$t('quotation_shortname')"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedRepair.CustomerFullName"
                              :label="$t('quotation_full_name')"
                              disabled
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedRepair.CarPlace"
                              :label="$t('quotation_car_place')"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-autocomplete
                              :items="allSpecialNeedList"
                              item-text="Name"
                              item-value="Name"
                              :label="$t('quotation_special_need')"
                              disabled
                              v-model="editedRepair.SpecialNeedList"
                              :loading-text="$t('common_get_data')"
                              :no-data-text="$t('common_no_results')"
                              small-chips
                              multiple
                              return-object
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <v-text-field v-model="editedRepair.Brand" disabled label="廠牌/車型">
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                            {{ $t('engineer_first_contact') }}
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedRepair.FirstContactName"
                              :label="$t('installation_notice_contact_name')"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedRepair.FirstContactPhone"
                              :label="$t('installation_notice_contact_name')"
                              disabled
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                            {{ $t('engineer_second_contact') }}
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedRepair.SecondContactName"
                              :label="$t('installation_notice_contact_name')"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedRepair.SecondContactPhone"
                              :label="$t('installation_notice_contact_name')"
                              disabled
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="2" sm="2" md="2" lg="2" xl="2" class="blue--text">
                            {{ $t('engineer_third_contact') }}
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedRepair.ThirdContactName"
                              :label="$t('installation_notice_contact_name')"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedRepair.ThirdContactPhone"
                              :label="$t('installation_notice_contact_name')"
                              disabled
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <ValidationObserver ref="repair">
                          <v-row>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="editedRepair.LicensePlate"
                                :label="$t('quotation_license_plate')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="editedRepair.OriginalLicensePlate"
                                :label="$t('quotation_original_license_plate')"
                                disabled
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-autocomplete
                                :items="maintenanceEngineers"
                                item-text="NickName"
                                item-value="UserName"
                                :label="$t('installation_notice_engineer')"
                                v-model="editedRepair.MaintenanceEngineers"
                                :loading-text="$t('common_get_data')"
                                :no-data-text="$t('common_no_results')"
                                disabled
                                small-chips
                                multiple
                              ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('installation_notice_point')"
                                :rules="{ required: true, regex: /^[0-9]+$/ }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedRepair.Point"
                                  :label="$t('installation_notice_point')"
                                  disabled
                                  :error-messages="errors[0]"
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('installation_notice_else_point')"
                                :rules="{ required: true, regex: /^[0-9]+$/ }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedRepair.ElsePoint"
                                  :label="$t('installation_notice_else_point')"
                                  :disabled="
                                    isAllTextFieldDisable ||
                                      editedRepair.IsAcceptance ||
                                      !editedRepair.IsDone
                                  "
                                  :error-messages="errors[0]"
                                  @keyup.enter="focusNextInput"
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <ValidationProvider
                                :name="$t('installation_notice_else_point_reason')"
                                v-if="editedRepair.ElsePoint != 0"
                                :rules="{ required: true }"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="editedRepair.ElsePointReason"
                                  :disabled="
                                    isAllTextFieldDisable ||
                                      editedRepair.IsAcceptance ||
                                      !editedRepair.IsDone
                                  "
                                  :error-messages="errors[0]"
                                  v-if="editedRepair.ElsePoint != 0"
                                  @keyup.enter="focusNextInput"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('installation_notice_else_point_reason') }}
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="editedRepair.QuotationNumber"
                                :label="$t('repair_quotation_number')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="editedRepair.QuotationName"
                                :label="$t('repair_quotation_name')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="editedRepair.FixNumber"
                                :label="$t('repair_fix_number')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="turnFixToRepairBy"
                                :label="$t('repair_fix_throw_by')"
                                disabled
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="turnDoneTime"
                                :label="$t('installation_acceptance_done_time')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-text-field
                                v-model="turnAcceptanceTime"
                                :label="$t('installation_acceptance_acceptance_time')"
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                              <v-select
                                v-model="editedRepair.TrackBy"
                                :items="tracks"
                                :label="$t('installation_acceptance_track_by')"
                                clearable
                                :disabled="
                                  isAllTextFieldDisable ||
                                    editedRepair.IsAcceptance ||
                                    !editedRepair.IsDone ||
                                    editedRepair.IsTrack
                                "
                                @keyup.enter="setTrackByAutocomplete"
                                ref="trackByAutocomplete"
                              ></v-select>
                            </v-col>
                          </v-row>
                        </ValidationObserver>
                        <v-row>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedRepair.RepairToResumeThrowUser.Name"
                              :label="$t('repair_throw_by')"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="turnResumeTime"
                              :label="$t('repair_throw_time')"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <date-picker-set-time-not-request
                              :time="editedRepair.SpecifyStopTime"
                              :dateName="'quotation_specify_stop_time'"
                              :minDate="minDate"
                              :isAllTextFieldDisabled="
                                isAllTextFieldDisable ||
                                  editedRepair.FixType !== 1 ||
                                  editedRepair.IsAcceptance ||
                                  !editedRepair.IsDone
                              "
                              @setDate="setSpecifyStopTime"
                              @keyupEnter="focusNextInput"
                            />
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedRepair.RepairToStockThrowUser.Name"
                              label="拋轉庫存異動單人"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="turnStockTime"
                              :label="$t('installation_acceptance_stock_time')"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedRepair.StockType"
                              label="庫存異動單單別"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedRepair.StockNumber"
                              label="庫存異動單單號"
                              disabled
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedRepair.RepairToSaleThrowUser.Name"
                              label="拋轉銷貨單人"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="turnSaleTime"
                              label="拋轉銷貨單時間"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedRepair.SaleType"
                              label="銷貨單別"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                            <v-text-field
                              v-model="editedRepair.SaleNumber"
                              label="銷貨單號"
                              disabled
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-textarea
                              v-model="editedRepair.Remark"
                              :label="$t('fix_dispatch_remark')"
                              :disabled="editedRepair.IsAcceptance"
                              rows="2"
                              outlined
                            ></v-textarea>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-textarea
                              v-model="editedRepair.InternalRemark"
                              :label="$t('fix_internal_remark')"
                              :disabled="editedRepair.IsAcceptance"
                              rows="2"
                              outlined
                            ></v-textarea>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-textarea
                              v-model="editedRepair.EngineerRemark"
                              :label="$t('fix_engineer_remark')"
                              :disabled="editedRepair.IsAcceptance"
                              rows="2"
                              outlined
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <!-- 維修品項 -維修單 -->
                    <repair-item
                      v-if="editedRepair.FixType !== 1"
                      :repairItemsInResume="editedRepair.InResumeItems"
                      :repairItemsNotInResume="editedRepair.NotInResumeItems"
                      :isAllTextFieldDisable="isAllTextFieldDisable"
                      :isDone="editedRepair.IsDone"
                      :isAcceptance="editedRepair.IsAcceptance"
                      @setEditedRepairItemIndex="setEditedRepairItemIndex"
                      @setEditedRemoveRepairItemInResume="setEditedRemoveRepairItemInResume"
                      @setEditedRemoveRepairItemNotInResume="setEditedRemoveRepairItemNotInResume"
                      @setDeleteNotExistRemoveRepairItem="setDeleteNotExistRemoveRepairItem"
                      @setDeleteExistRemoveRepairItem="setDeleteExistRemoveRepairItem"
                      @setRepairItemIsNeedThrowResume="setRepairItemIsNeedThrowResume"
                    />

                    <!-- 拆機品項-維修單 -->
                    <repair-remove-item
                      v-if="editedRepair.FixType === 1"
                      :repairItemsInResume="editedRepair.InResumeItems"
                      :repairItemsNotInResume="editedRepair.NotInResumeItems"
                      :isAllTextFieldDisable="isAllTextFieldDisable"
                      :isDone="editedRepair.IsDone"
                      :isAcceptance="editedRepair.IsAcceptance"
                      @setEditedRepairItemIndex="setEditedRepairItemIndex"
                      @setEditedRemoveRepairItemInResume="setEditedRemoveRepairItemInResume"
                      @setEditedRemoveRepairItemNotInResume="setEditedRemoveRepairItemNotInResume"
                      @setDeleteNotExistRemoveRepairItem="setDeleteNotExistRemoveRepairItem"
                      @setDeleteExistRemoveRepairItem="setDeleteExistRemoveRepairItem"
                      @setRemoveRepairItemIsNeedThrowResume="setRemoveRepairItemIsNeedThrowResume"
                    />
                  </v-card>
                </v-tab-item>
                <v-tab-item value="tab-2">
                  <v-row>
                    <v-col cols="2" v-for="fixImage in fixImageList" :key="fixImage">
                      <v-card flat>
                        <v-img :src="fixImage"></v-img>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item value="tab-3">
                  <v-row>
                    <v-col
                      cols="2"
                      v-for="(repairImage, index) in repairImageList"
                      :key="repairImage"
                    >
                      <v-card flat>
                        <v-img :src="repairImage"></v-img>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="error"
                            @click="deletePhoto(index)"
                            :disabled="editedRepair.IsAcceptance || !editedRepair.IsDone"
                          >
                            {{ $t('common_delete') }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item value="tab-4">
                  <v-card flat>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <v-text-field
                              v-model="editedRepair.TpAccount"
                              label="環保帳號"
                              disabled
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <v-text-field
                              v-model="editedRepair.TpPassword"
                              label="環保密碼"
                              disabled
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="closeEditedRepair"
                  :disabled="isAllTextFieldDisable"
                >
                  {{ $t('common_close') }}
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click="saveEditedRepair"
                  :loading="isLoadingSaveBtn"
                  :disabled="editedRepair.IsAcceptance"
                >
                  {{ $t('common_save') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn icon @click="isShowEditRepairDialogBtn(item)">
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.Status`]="{ item }">
        {{ methodsStatus(item) }}
      </template>
      <template v-slot:[`item.SpecialNeedList`]="{ item }">
        {{ turnSpecialNeedName(item.SpecialNeedList) }}
      </template>
    </v-data-table>
  </div>
</template>
<style scoped>
.red {
  background-color: red !important;
}
.yellow {
  background-color: yellow !important;
}
</style>
<script>
import { HttpRepair, HttpFix, HttpUser, HttpSpecialNeed, HttpCustomer } from '@/js/http-Manager'
import { extend } from 'vee-validate'
import { regex } from 'vee-validate/dist/rules'
import CustomerAutocompleteFilter from '@/components/CustomerAutocompleteFilter.vue'
import DatePicker from '@/components/DatePicker.vue'
import RepairRemoveItem from '@/components/Repair/RepairRemoveItem.vue'
import RepairItem from '@/components/Repair/RepairItem.vue'
import DatePickerSetTimeNotRequest from '@/components/DatePickerSetTimeNotRequest.vue'
import { FixType } from '@/js/FixType'

extend('regex', regex)
export default {
  components: {
    CustomerAutocompleteFilter,
    DatePicker,
    RepairRemoveItem,
    RepairItem,
    DatePickerSetTimeNotRequest
  },
  name: 'Repair',
  data: () => ({
    remarkDialog: false,
    remarkItem: {},
    fixType: FixType,
    isShowEditRepairDialog: false,
    repairList: [],
    editedRepairIndex: -1,
    editedRepair: {
      FixType: 0,
      FixSubject: '',
      CustomerId: '',
      Number: '',
      CustomerNumber: '',
      CustomerName: '',
      FirstContactName: '',
      FirstContactPhone: '',
      SecondContactName: '',
      SecondContactPhone: '',
      ThirdContactName: '',
      ThirdContactPhone: '',
      CarPlace: '',
      QuotationNumber: '',
      QuotationName: '',
      FixNumber: '',
      FixReason: '',
      LicensePlate: '',
      Point: 0,
      ElsePoint: 0,
      ElsePointReason: '',
      MaintenanceEngineers: [],
      IsAccept: false,
      AcceptTime: 0,
      IsOutOfTime: false,
      OutOfTime: 0,
      IsDone: false,
      DoneTime: 0,
      TrackBy: '',
      IsTrack: false,
      IsAcceptance: false,
      AcceptanceTime: 0,
      IsThrowToResume: false,
      IsThrowToStock: false,
      IsThrowToMonth: false,
      IsThrowToSale: false,
      FixToRepairThrowUser: {
        ThrowTime: 0,
        Name: ''
      },
      RepairItems: [],
      InResumeItems: [],
      NotInResumeItems: [],
      RepairToResumeThrowUser: {
        ThrowTime: 0,
        Name: ''
      },
      RepairToStockThrowUser: {
        ThrowTime: 0,
        Name: ''
      },
      RepairToSaleThrowUser: {
        ThrowTime: 0,
        Name: ''
      },
      FixFileNameList: [],
      FileNameList: [],
      SpecialNeedList: [],
      TpAccount: '',
      TpPassword: '',
      Brand: '',
      Remark: '',
      SpecifyStopTime: 0,
      StockType: '',
      StockNumber: '',
      SaleType: '',
      SaleNumber: '',
      ZoneType: 0,
      RelativeNoticeNumber: '',
      IsCancel: false,
      InternalRemark: '',
      EngineerRemark: ''
    },
    defaultRepair: {
      FixType: 0,
      FixSubject: '',
      CustomerId: '',
      Number: '',
      CustomerNumber: '',
      CustomerName: '',
      FirstContactName: '',
      FirstContactPhone: '',
      SecondContactName: '',
      SecondContactPhone: '',
      ThirdContactName: '',
      ThirdContactPhone: '',
      CarPlace: '',
      QuotationNumber: '',
      QuotationName: '',
      FixNumber: '',
      FixReason: '',
      LicensePlate: '',
      Point: 0,
      ElsePoint: 0,
      ElsePointReason: '',
      MaintenanceEngineers: [],
      IsAccept: false,
      AcceptTime: 0,
      IsOutOfTime: false,
      OutOfTime: 0,
      IsDone: false,
      DoneTime: 0,
      TrackBy: '',
      IsTrack: false,
      IsAcceptance: false,
      AcceptanceTime: 0,
      IsThrowToResume: false,
      IsThrowToStock: false,
      IsThrowToMonth: false,
      IsThrowToSale: false,
      FixToRepairThrowUser: {
        ThrowTime: 0,
        Name: ''
      },
      RepairItems: [],
      InResumeItems: [],
      NotInResumeItems: [],
      RepairToResumeThrowUser: {
        ThrowTime: 0,
        Name: ''
      },
      RepairToStockThrowUser: {
        ThrowTime: 0,
        Name: ''
      },
      RepairToSaleThrowUser: {
        ThrowTime: 0,
        Name: ''
      },
      FixFileNameList: [],
      FileNameList: [],
      SpecialNeedList: [],
      TpAccount: '',
      TpPassword: '',
      Brand: '',
      Remark: '',
      SpecifyStopTime: 0,
      StockType: '',
      StockNumber: '',
      SaleType: '',
      SaleNumber: '',
      ZoneType: 0,
      RelativeNoticeNumber: '',
      IsCancel: false,
      InternalRemark: '',
      EngineerRemark: ''
    },
    isRepairLoading: true,
    isLoadingSaveBtn: false,
    isAllTextFieldDisable: false,

    totalRows: 0,
    currentOptions: {
      // default DataTable Options
      page: 1,
      itemsPerPage: 30,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      triggerByOutsite: true
    },
    isUpdateEventTotal: true,
    filterRepair: {
      CustomerId: '',
      RepairNumber: '',
      LicensePlate: '',
      MaintenanceEngineers: [],
      StartDoneTime: 0,
      EndDoneTime: 0,
      SpecialNeedId: ''
    },

    maintenanceEngineers: [],
    returnFix: {
      Reason: '',
      Number: ''
    },
    NotAccept: false,
    tracks: ['工務追', '業務追', '客服追'],
    fixImageList: [],
    repairImageList: [],
    isShowBackDialog: false,
    backReason: '',
    allSpecialNeedList: [],
    minDate: '',
    isLoadingThrowFlowBtn: false
  }),
  watch: {},
  async mounted () {
    await this.countTotalRows()
    await this.getRepair()
    await this.getEngineerUser()
    await this.getSpecialNeedList()
  },
  computed: {
    repairDataTableHeaders () {
      return [
        {
          text: this.$t('serialnumber_repair_number'),
          align: 'start',
          value: 'Number'
        },
        { text: this.$t('quotation_customer_number'), align: 'start', value: 'CustomerNumber' },
        { text: this.$t('quotation_shortname'), align: 'start', value: 'CustomerName' },
        { text: this.$t('quotation_full_name'), align: 'start', value: 'CustomerFullName' },
        { text: this.$t('quotation_license_plate'), align: 'start', value: 'LicensePlate' },
        {
          text: this.$t('quotation_original_license_plate'),
          align: 'start',
          value: 'OriginalLicensePlate'
        },
        {
          text: this.$t('installation_notice_engineer'),
          align: 'start',
          value: 'EngineersNickName'
        },
        {
          text: this.$t('quotation_special_need'),
          align: 'start',
          value: 'SpecialNeedList'
        },
        { text: this.$t('installation_notice_point'), align: 'end', value: 'Point' },
        { text: this.$t('installation_notice_else_point'), align: 'end', value: 'ElsePoint' },
        { text: this.$t('installation_acceptance_track_by'), align: 'start', value: 'TrackBy' },
        { text: this.$t('common_status'), align: 'center', value: 'Status', sortable: false },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    },

    turnFixToRepairDate () {
      if (this.editedRepair.FixToRepairThrowUser) {
        return this.convertToDateTimeFormat(this.editedRepair.FixToRepairThrowUser.ThrowTime)
      }
      return 0
    },
    turnFixToRepairBy () {
      if (this.editedRepair.FixToRepairThrowUser) {
        return this.editedRepair.FixToRepairThrowUser.Name
      }
      return ''
    },

    turnDoneTime () {
      return this.convertToDateTimeFormat(this.editedRepair.DoneTime)
    },
    turnAcceptanceTime () {
      return this.convertToDateTimeFormat(this.editedRepair.AcceptanceTime)
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },

    turnResumeTime () {
      if (this.editedRepair.RepairToResumeThrowUser) {
        return this.convertToDateTimeFormat(this.editedRepair.RepairToResumeThrowUser.ThrowTime)
      }
      return ''
    },
    turnStockTime () {
      if (this.editedRepair.RepairToStockThrowUser) {
        return this.convertToDateTimeFormat(this.editedRepair.RepairToStockThrowUser.ThrowTime)
      }
      return ''
    },
    turnSaleTime () {
      if (this.editedRepair.RepairToSaleThrowUser) {
        return this.convertToDateTimeFormat(this.editedRepair.RepairToSaleThrowUser.ThrowTime)
      }
      return ''
    }
  },
  methods: {
    hasAnyRemark (item) {
      return !!(item.Remark || item.InternalRemark || item.EngineerRemark)
    },
    openRemarkDialog (item) {
      this.remarkItem = item
      this.remarkDialog = true
    },
    async getMinDate () {
      if (this.editedRepair.CustomerNumber) {
        let response = await HttpCustomer.GetCustomerByNumber({
          number: this.editedRepair.CustomerNumber
        })
        let settleDay = response && response.status === 200 ? response.data.Data.SettleDay : 0
        let currentDate = new Date()
        let previousMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)
        let lastDayOfPreviousMonth = new Date(
          previousMonth.getFullYear(),
          previousMonth.getMonth() + 1,
          0
        ).getDate()

        let finalDay = Math.min(settleDay, lastDayOfPreviousMonth)
        let minDate = new Date(previousMonth.getFullYear(), previousMonth.getMonth(), finalDay + 1)
        this.minDate = this.$moment(new Date(minDate)).format('YYYY-MM-DD')
      } else {
        this.minDate = ''
      }
    },
    setSpecifyStopTime (val) {
      this.editedRepair.SpecifyStopTime = val * 1
    },
    setTrackByAutocomplete (event) {
      this.$refs.trackByAutocomplete.isMenuActive = false
      this.$refs.trackByAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (form[i].type !== 'hidden' && !form[i].disabled && form[i].type !== 'checkbox') {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    turnSpecialNeedName (value) {
      if (value) {
        let str = []
        let temp = 0
        value.forEach((element) => {
          str.push(element.Name)
          temp++
        })
        str = JSON.stringify(str)
        str = str.replace('[', '').replace(']', '')
        for (let index = 0; index < temp * 2; index++) {
          str = str.replace('"', '')
        }
        return str
      }
    },
    async getSpecialNeedList () {
      let response = await HttpSpecialNeed.GetSpecialNeed()
      this.allSpecialNeedList = response.status === 200 ? response.data.Data : []
    },
    async getEngineerUser () {
      let response = await HttpUser.GetEngineerUser()
      this.maintenanceEngineers = response.status === 200 ? response.data.Data : []
    },
    async isBack () {
      await HttpRepair.UpdateRepairIsDelete(this.editedRepair.Id)
      await HttpFix.IsBackRepair({
        number: this.editedRepair.FixNumber,
        reason: this.backReason
      })
      await this.closeEditedRepair()
      this.backReason = ''
    },
    async deletePhoto (index) {
      await HttpRepair.DeleteImage({
        repairNumber: this.editedRepair.Number,
        fileName: this.editedRepair.FileNameList[index]
      })
      this.editedRepair.FileNameList.splice(index, 1)
      await HttpRepair.UpdateRepair(this.editedRepair)
      await this.getPhoto()
      await this.searchEditedRepair()
    },
    async getPhoto () {
      if (this.editedRepair.FileNameList && this.editedRepair.FileNameList.length > 0) {
        let response = await HttpRepair.GetImage({
          repairNumber: this.editedRepair.Number,
          repairFileList: this.editedRepair.FileNameList.join(',')
        })
        this.repairImageList = response.status === 200 ? response.data.Data : []
      }
    },
    async uploadPhoto (event) {
      if (event.target.files.length > 0) {
        let formData = new FormData()
        for (var i = 0; i < event.target.files.length; i++) {
          formData.append('Files', event.target.files[i])
        }

        formData.append('Number', this.editedRepair.Number)
        await HttpRepair.UploadImage(formData)
        console.log(event.target.files)
        if (!this.editedRepair.FileNameList) {
          this.editedRepair.FileNameList = []
        }
        if (!this.editedRepair.FileNameList) {
          this.editedRepair.FileNameList = []
        }
        for (let i = 0; i < event.target.files.length; i++) {
          this.editedRepair.FileNameList.push(event.target.files[i].name)
        }
        await HttpRepair.UpdateRepair(this.editedRepair)
        await this.getPhoto()
        await this.searchEditedRepair()
      }
    },
    openFileDialog () {
      this.$refs.file.click()
    },
    async getFixPhoto () {
      if (this.editedRepair.FixFileNameList && this.editedRepair.FixFileNameList.length > 0) {
        let response = await HttpFix.GetImage({
          fixNumber: this.editedRepair.FixNumber,
          fixFileList: this.editedRepair.FixFileNameList.join(',')
        })
        this.fixImageList = response.status === 200 ? response.data.Data : []
      }
    },
    setStartDoneTime (val) {
      this.filterRepair.StartDoneTime = val * 1
    },
    setEndDoneTime (val) {
      this.filterRepair.EndDoneTime = val * 1
    },

    async setFilterCustomer (val) {
      this.filterRepair.CustomerId = val.Id
      this.filterRepair = JSON.parse(JSON.stringify(this.filterRepair))
    },
    async throwMonth () {
      await HttpRepair.TransferRepairToMonth(this.editedRepair)
      await this.getRepair()
      await this.searchEditedRepair()
    },
    async throwFlow () {
      this.isLoadingThrowFlowBtn = true
      let response = await HttpRepair.NewTransferSunlikeFlow(this.editedRepair)
      if (response && response.status === 200) {
        let checkExistData = response.data.Data
        if (checkExistData.IsExist) {
          alert(checkExistData.Message)
        }
        await this.getRepair()
        await this.searchEditedRepair()
        if (
          this.editedRepair.FixType === this.fixType.RemoveFix ||
          this.editedRepair.FixType === this.fixType.MoveFix
        ) {
          await this.throwMonth()
        }
      }
      this.isLoadingThrowFlowBtn = false
    },
    methodsStatus (value) {
      if (value.IsAccept && !value.IsDone) {
        return this.$t('installation_acceptance_status_accept')
      } else if (value.IsDone && !value.IsTrack && !value.IsAcceptance) {
        return this.$t('installation_acceptance_status_done')
      } else if (value.IsTrack && !value.IsAcceptance) {
        return this.$t('installation_acceptance_track_btn')
      } else if (value.IsAcceptance && !value.IsThrowToResume) {
        return this.$t('installation_acceptance_status_acceptance')
      } else if (value.IsThrowToResume && !value.IsThrowToStock) {
        return this.$t('repair_status_throw')
      } else if (value.IsThrowToStock) {
        return this.$t('repair_throw_stock_status')
      } else {
        return this.$t('installation_acceptance_status_is_accept')
      }
    },
    async searchEditedRepair () {
      let param = {
        id: this.editedRepair.Id,
        number: this.editedRepair.Number
      }
      let response = await HttpRepair.SearchEditedRepair(param)
      this.editedRepair = response.status === 200 ? response.data.Data : []
    },
    async isTrack () {
      const isValid = await this.$refs.repair.validate()
      if (isValid) {
        this.editedRepair.IsTrack = true
        await HttpRepair.UpdateRepair(this.editedRepair)
        await this.getRepair()
        await this.searchEditedRepair()
      }
    },
    async isAcceptance () {
      let isBuyOrRentTypeNull = this.editedRepair.InResumeItems.find(
        (x) =>
          (x.RemoveItem && x.RemoveItem.ItemId && !x.RemoveItem.BuyOrRentType) ||
          (x.ReturnItem && x.ReturnItem.ItemId && !x.ReturnItem.BuyOrRentType)
      )

      if (!isBuyOrRentTypeNull) {
        isBuyOrRentTypeNull = this.editedRepair.NotInResumeItems.find(
          (x) =>
            (x.RemoveItem && x.RemoveItem.ItemId && !x.RemoveItem.BuyOrRentType) ||
            (x.ReturnItem && x.ReturnItem.ItemId && !x.ReturnItem.BuyOrRentType)
        )
      } else {
        alert('在履歷卡品項，請填寫買/租類型')
      }
      if (!isBuyOrRentTypeNull) {
        this.editedRepair.IsAcceptance = true
        this.editedRepair.IsTrack = false
        this.editedRepair.TrackBy = ''
        await HttpRepair.UpdateRepair(this.editedRepair)
        await this.getRepair()
        await this.searchEditedRepair()
      } else {
        alert('不在履歷卡品項，請填寫買/租類型')
      }
    },
    async saveEditedRepair () {
      await HttpRepair.UpdateRepair(this.editedRepair)
      await this.getRepair()
      await this.closeEditedRepair()
    },
    async countTotalRows () {
      if (this.isUpdateEventTotal) {
        var maintenanceEngineers = ''
        if (this.filterRepair.MaintenanceEngineers.length !== 0) {
          this.filterRepair.MaintenanceEngineers.forEach((element, index) => {
            if (index === this.filterRepair.MaintenanceEngineers.length - 1) {
              maintenanceEngineers += element
            } else {
              maintenanceEngineers = maintenanceEngineers + element + ','
            }
          })
        }
        let param = {
          RepairNumber: this.filterRepair.RepairNumber,
          customerId: this.filterRepair.CustomerId,
          licensePlate: this.filterRepair.LicensePlate,
          maintenanceEngineers: maintenanceEngineers,
          startDoneTime: this.filterRepair.StartDoneTime,
          endDoneTime: this.filterRepair.EndDoneTime,
          specialNeedId: this.filterRepair.SpecialNeedId
        }
        let response = await HttpRepair.GetRepairCount(param)
        this.totalRows = response.status === 200 ? response.data.Data : 0
      }
    },
    async updateOptions (val) {
      this.currentOptions = val
      this.isUpdateEventTotal = false
      await this.getRepair(val)
    },
    async getRepair (val) {
      if (this.isUpdateEventTotal) {
        this.currentOptions.page = 1
        this.countTotalRows()
      }
      this.isUpdateEventTotal = true
      this.isRepairLoading = true
      var maintenanceEngineers = ''
      if (this.filterRepair.MaintenanceEngineers.length !== 0) {
        this.filterRepair.MaintenanceEngineers.forEach((element, index) => {
          if (index === this.filterRepair.MaintenanceEngineers.length - 1) {
            maintenanceEngineers += element
          } else {
            maintenanceEngineers = maintenanceEngineers + element + ','
          }
        })
      }

      let param = {
        RepairNumber: this.filterRepair.RepairNumber,
        customerId: this.filterRepair.CustomerId,
        licensePlate: this.filterRepair.LicensePlate,
        maintenanceEngineers: maintenanceEngineers,
        startDoneTime: this.filterRepair.StartDoneTime,
        endDoneTime: this.filterRepair.EndDoneTime,
        specialNeedId: this.filterRepair.SpecialNeedId,
        itemsPerPage:
          typeof val === 'object' && val.itemsPerPage > 0
            ? val.itemsPerPage
            : this.currentOptions.itemsPerPage,
        page: typeof val === 'object' && val && val.page > 0 ? val.page : this.currentOptions.page,
        sortBy:
          typeof val === 'object' && val.sortBy ? val.sortBy[0] : this.currentOptions.sortBy[0],
        sortDesc:
          typeof val === 'object' && val.sortBy ? val.sortDesc[0] : this.currentOptions.sortDesc[0]
      }

      let response = await HttpRepair.GetRepair(param)
      this.isRepairLoading = false
      this.repairList = response.status === 200 ? response.data.Data : []
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    async closeEditedRepair () {
      this.isShowEditRepairDialog = false
      this.isRepairLoading = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultRepair)
        this.editedRepair = JSON.parse(str)
        this.editedRepairIndex = -1
      })
      await this.getRepair()
    },
    async isShowEditRepairDialogBtn (item) {
      this.editedRepairIndex = this.repairList.indexOf(item)
      let response = await HttpRepair.UpdateIsOutOfWarranty(item)
      this.editedRepair = response.status === 200 ? response.data.Data : {}
      await this.getMinDate()
      await this.getFixPhoto()
      await this.getPhoto()
      this.isShowEditRepairDialog = true
    },

    setEditedRepairItemIndex (val) {
      this.editedRepairItemIndex = val
    },
    setEditedRemoveRepairItemInResume (val) {
      if (this.editedRepairItemIndex > -1) {
        this.editedRepair.InResumeItems.splice(this.editedRepairItemIndex, 1, val)
      } else {
        this.editedRepair.InResumeItems.push(val)
      }
    },
    setEditedRemoveRepairItemNotInResume (val) {
      if (this.editedRepairItemIndex > -1) {
        this.editedRepair.NotInResumeItems.splice(this.editedRepairItemIndex, 1, val)
      } else {
        this.editedRepair.NotInResumeItems.push(val)
      }
    },
    setDeleteNotExistRemoveRepairItem (val) {
      this.editedRepair.NotInResumeItems.splice(val, 1)
    },
    setDeleteExistRemoveRepairItem (val) {
      this.editedRepair.InResumeItems.splice(val, 1)
    },
    setRemoveRepairItemIsNeedThrowResume (notThrowList) {
      this.editedRepair.NotInResumeItems.forEach((element, index) => {
        let isExist = notThrowList.findIndex((x) => x.Index === index) === -1
        element.RemoveItem.IsNeedThrowResume = isExist
      })
      this.editedRepair.NotInResumeItems = JSON.parse(
        JSON.stringify(this.editedRepair.NotInResumeItems)
      )
    },
    setRepairItemIsNeedThrowResume (notThrowList) {
      this.editedRepair.NotInResumeItems.forEach((element, index) => {
        let isExist = notThrowList.findIndex((x) => x.Index === index) === -1
        if (
          element.RemoveItem &&
          typeof element.RemoveItem.ItemId !== 'undefined' &&
          element.RemoveItem.ItemId !== ''
        ) {
          element.RemoveItem.IsNeedThrowResume = isExist
        } else {
          element.ReturnItem.IsNeedThrowResume = isExist
        }
      })
      this.editedRepair.NotInResumeItems = JSON.parse(
        JSON.stringify(this.editedRepair.NotInResumeItems)
      )
    }
  }
}
</script>
